import { render, staticRenderFns } from "./patientAlertReport.vue?vue&type=template&id=ba66e71c"
import script from "./patientAlertReport.vue?vue&type=script&lang=js"
export * from "./patientAlertReport.vue?vue&type=script&lang=js"
import style0 from "./patientAlertReport.vue?vue&type=style&index=0&id=ba66e71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports